import React from 'react';
import { Button } from 'react-bootstrap';

import Table from '../../../../facturotopia/table/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FormaDePagoPOptions from '../../support/catalogs/complementos/pagos/FormaDePagoPOptions';
import moment from 'moment';

const PagoList = ({ data = [], onEdit, onDelete }) => {
  const handleEdit = (item) => {
    onEdit(item);
  };

  const handleDelete = (item) => {
    onDelete(item);
  };

  return (
    <Table
      columns={columns(handleEdit, handleDelete)}
      rowKey={'id'}
      data={data}
    ></Table>
  );
};

const columns = (handleEdit, handleDelete) => [
  {
    align: 'center',
    key: '__',
    title: '',
    dataIndex: '__',
    render: (item) => {
      return (
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={handleEdit.bind(null, item)}
          >
            <FontAwesomeIcon icon={['far', 'edit']} />
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={handleDelete.bind(null, item)}
          >
            <FontAwesomeIcon icon={['fas', 'trash']} />
          </Button>
        </>
      );
    },
  },
  {
    align: 'center',
    key: 'NumParcialidad',
    title: 'Parcialidad',
    dataIndex: 'NumParcialidad',
  },
  {
    align: 'center',
    key: 'IdDocumento',
    title: 'UUID',
    dataIndex: 'IdDocumento',
  },
  {
    align: 'center',
    key: 'FechaPago',
    title: 'Fecha Pago',
    dataIndex: 'FechaPago',
    render: (item) => {
      return moment(item.FechaPago).format('YYYY-MM-DD') + 'T' + (item.HoraPago ?? '12:00') + ':00';
    },
  },
  {
    align: 'center',
    key: 'MonedaP',
    title: 'Moneda',
    dataIndex: 'MonedaP',
  },
  {
    align: 'center',
    key: 'EquivalenciaDR',
    title: 'Equivalencia',
    dataIndex: 'EquivalenciaDR',
  },
  {
    align: 'center',
    key: 'FormaDePagoP',
    title: 'Forma de Pago',
    dataIndex: 'FormaDePagoP',
    render: (item) => {
      let label = item.FormaDePagoP;

      FormaDePagoPOptions.forEach((element) => {
        if (item.FormaDePagoP === element.value) {
          label = element.label;
        }
      });

      return <>{label}</>;
    },
  },
  {
    size: 'md',
    align: 'right',
    key: 'Monto',
    title: 'Monto',
    dataIndex: 'Monto',
  },
  {
    align: 'right',
    className: 'cell-small',
    key: 'ImpSaldoAnt',
    title: 'Saldo Anterior',
    dataIndex: 'ImpSaldoAnt',
  },
  {
    align: 'right',
    className: 'cell-small',
    key: 'ImpSaldoInsoluto',
    title: 'Saldo Insoluto',
    dataIndex: 'ImpSaldoInsoluto',
  },
];

export default PagoList;
